import {
  makeAutoObservable,
  autorun,
  set,
  reaction,
  toJS,
  extendObservable,
} from "mobx";
import axios from "axios";
import { prefApi } from "./api";

function autoSave(_this, name) {
  console.log("autoSave" + name);

  const storedJson = localStorage.getItem(name);
  if (storedJson) {
    console.log("update!" + name);
    console.log(storedJson);
    set(_this, JSON.parse(storedJson));
  }
  autorun(() => {
    console.log("autorun");
    const value = toJS(_this);
    localStorage.setItem(name, JSON.stringify(value));
  });
}

const storeName = "store_form3";
class Form {
  data = {
    selected_item: null,
    items: [
      { name: "Техничекая поддержка", id: 1 },
      { name: "Гарантия", id: 2 },
      { name: "Другое", id: 3 },
    ],
    name: "",
    body: "",
  };
  message = null;

  constructor() {
    // this.initData();
    makeAutoObservable(this);
    autoSave(this.data, "store_form"); // Only store property `count`
  }
  async initData() {
    const dataFromStore = JSON.parse(localStorage.getItem(storeName));
    console.log("LOAD:::dataFromStore");
    console.log(dataFromStore);
    if (dataFromStore !== null && typeof dataFromStore !== "undefined") {
      this.data = dataFromStore;
      console.log("{UPPP}");
      console.log(this.data);
    }
    makeAutoObservable(this);
    autorun(() => {
      console.log("SAVE::: autorun");
      const value = toJS(this.data);
      const valueName = toJS(this.data.name);
      const valueBody = toJS(this.data.body);
      const valueItem = toJS(this.data.selected_item);
      localStorage.setItem(storeName, JSON.stringify(value));
    });
  }

  loadFromLocalStore() {
    return JSON.parse(localStorage.getItem(this.store_name));
  }

  get getLocalData() {
    return this.data;
  }

  // #### SETTERS
  setName(val) {
    console.log(val);
    this.data.name = val;
    this.message = val;
  }
  setItem(val) {
    console.log(val);
    this.data.selected_item = val;
  }
  setBody(val) {
    console.log(val);
    this.data.body = val;
  }
  //### ACTIONS
  sentForm() {
    console.log("UPLOAD PAGE:" + this.curent_page);
    this.loading = true;
    /* fetch('/api/events/get', {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ limit: this.page_limit, page: this.curent_page })
        })
            .then(resp => resp.json())
            .then(json => { }) */
    axios
      .post(prefApi + "/form/sent", {
        data: {
          name: this.getLocalData.name,
          subject:
            (this.getLocalData.selected_item !== null &&
              this.getLocalData.selected_item.name) ||
            "None",
          body: this.getLocalData.body,
        },
      })
      .then((response) => {
        console.log(response);

        if (response.data.errorCode === 0) {
          this.message = "Сообщение отпрвленно!";
        } else {
          this.message = "Ошибка!";
        }
        /*  this.categories = response.data; */
      })
      .catch((error) => {
        console.error(error);
        this.message = "Ошибка!";
      });
  }
}

const FormObj = new Form();
export default FormObj;
